var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnySupplementaryOxygen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    transform: "rotate(0 0 0)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.71139 8.95801C2.31512 8.9781 2 9.30577 2 9.70703C2 10.1212 2.33579 10.457 2.75 10.457H5.25L5.25 15.4243C4.65876 15.7051 4.25 16.3078 4.25 17.0059C4.25 17.9724 5.0335 18.7559 6 18.7559C6.9665 18.7559 7.7501 17.9724 7.7501 17.0059C7.7501 16.3077 7.34129 15.7051 6.75 15.4242V13.7559H17.25V15.4243C16.6588 15.7051 16.25 16.3078 16.25 17.0059C16.25 17.9724 17.0335 18.7559 18 18.7559C18.9665 18.7559 19.7501 17.9724 19.7501 17.0059C19.7501 16.3077 19.3413 15.7051 18.75 15.4242V10.457H21.25C21.6642 10.457 22 10.1212 22 9.70703C22 9.30577 21.6849 8.9781 21.2886 8.95801H2.71139ZM17.25 12.2559H6.75V10.457H17.25V12.2559Z",
    fill: "currentColor"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.25 8.20703C3.25 6.96439 4.25736 5.95703 5.5 5.95703H5.92203C7.05919 5.95703 8.0176 6.80552 8.15544 7.9343L8.18886 8.20801L3.25 8.20703Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.75 8.20801C20.75 6.96537 19.7426 5.95703 18.5 5.95703H11.078C9.94081 5.95703 8.9824 6.80552 8.84456 7.9343L8.81114 8.20801H20.75Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnySupplementaryOxygen);
export default __webpack_public_path__ + "static/media/AnySupplementaryOxygen.dc9eff28a78cf27a9f979ef961048267.svg";
export { ForwardRef as ReactComponent };